// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"66":"Item","119":"Information","438":"Rune_list","688":"Modifier","776":"Skill_page"}[chunkId] + "." + {"66":"d562e820","119":"ae7d1bc3","438":"b24bcdbe","688":"a0e27c7c","776":"b0f8d059"}[chunkId] + ".chunk.css";
};